import { render, staticRenderFns } from "./CustomFieldColumn.vue?vue&type=template&id=584132da&scoped=true&"
import script from "./CustomFieldColumn.vue?vue&type=script&lang=js&"
export * from "./CustomFieldColumn.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldColumn.vue?vue&type=style&index=0&id=584132da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584132da",
  null
  
)

export default component.exports